import { createRouter, createWebHistory } from "vue-router";
import ChatView from "../views/ChatView.vue";

const routes = [
  {
    path: "/:lang?",
    name: "chat",
    component: ChatView,
    beforeEnter: (to, from, next) => {
      const lang = to.params.lang || "de";
      if (["de", "en", "fr", "it"].includes(lang)) {
        next();
      } else {
        next({ name: "chat", params: { lang: "de" } }); // Redirect to German if invalid language
      }
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
